function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import { useOnClickOutside } from 'hooks';
import OpenInNewIcon from 'svg/open-in-new.svg';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import PatientResults from 'modules/PatientResults';
import { REPORTS, NEW_CDA_REPORTS } from './reports';
import styles from './ReportButton.pcss';
const ReportDropdown = ({ storeSelectedReportTypes, goToReportsView, isInProgress, isOpen, setIsOpen })=>{
    const isNewCDAReportsVisible = useSelector(App.selectors.isNewCDAReportsVisible);
    const dropdownRef = useRef(null);
    const [selectedReports, setSelectedReports] = useState([]);
    useEffect(()=>{
        if (isInProgress && isOpen) {
            setIsOpen(false);
            setSelectedReports([]);
        }
    }, [
        isInProgress,
        isOpen
    ]);
    const isReportSelected = (report)=>selectedReports.includes(report);
    const onClickOutside = useCallback(()=>{
        setIsOpen(false);
        setSelectedReports([]);
    }, []);
    useOnClickOutside(dropdownRef, onClickOutside);
    const onReportClick = (reportType)=>{
        setSelectedReports((prev)=>prev.includes(reportType) ? prev.filter((r)=>r !== reportType) : [
                ...prev,
                reportType
            ]);
    };
    const onViewSelected = ()=>{
        storeSelectedReportTypes(selectedReports);
        goToReportsView();
        setIsOpen(false);
        setSelectedReports([]);
    };
    if (!isOpen) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.topBar__generateReportDropdown,
        ref: dropdownRef,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.reportSelector__dropDownContent,
            children: [
                REPORTS.map(({ id, Icon, message })=>{
                    const isNewCDAReport = NEW_CDA_REPORTS.includes(id);
                    if (isNewCDAReport && !isNewCDAReportsVisible) {
                        return null;
                    }
                    const isActive = isReportSelected(id);
                    return /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        className: cn(styles.reportSelector__button, {
                            [styles['reportSelector__button--isActive']]: isActive
                        }),
                        onClick: ()=>onReportClick(id),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.reportSelector__checkbox,
                                children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                                    id: id,
                                    inputValue: id,
                                    value: isActive ? id : '',
                                    onChange: ()=>null
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.reportSelector__icon,
                                children: /*#__PURE__*/ _jsx(Icon, {})
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.reportSelector__label,
                                children: [
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message)),
                                    isNewCDAReport && ' DEV ONLY'
                                ]
                            })
                        ]
                    }, id);
                }),
                /*#__PURE__*/ _jsxs("button", {
                    type: "button",
                    className: cn(styles.reportSelector__viewSelectedButton, {
                        [styles['reportSelector__viewSelectedButton--disabled']]: selectedReports.length === 0
                    }),
                    onClick: onViewSelected,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.viewSelected)),
                        /*#__PURE__*/ _jsx(OpenInNewIcon, {})
                    ]
                })
            ]
        })
    });
};
export default ReportDropdown;
